export const TROPHY_GIF_PATH =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/1aa9118c32979b15b630c597863ff2b2-1630418540858/Gold-Trophy-96-Alpha.gif';
export const SOURCE_COMPONENT = 'recommendation_returning_buyers';
